export default "__VITE_ASSET__DGG5VGL0__"